import { useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PillLauncherExpandedView from 'conversations-visitor-experience-components/visitor-widget/components/PillLauncherExpandedView';
import { useCustomerAgentHover } from 'conversations-visitor-experience-components/contexts/CustomerAgentHoverContext';
import { useAIPromptRecommendations } from '../../hooks/useAIPromptRecommendations';
import { toggleOpen } from '../../actions/WidgetActions';
import { getColoring } from '../../selectors/widgetDataSelectors/getColoring';
import { useConsentPromptDataV2 } from '../../hooks/useConsentPromptDataV2';
import { hasPersistedThreads } from '../../threads/selectors/hasPersistedThreads';
import { jsx as _jsx } from "react/jsx-runtime";
const PillLauncherExpandedViewContainer = ({
  clickedFrom
}) => {
  const dispatch = useDispatch();
  const {
    isHoverActive
  } = useCustomerAgentHover();
  const coloring = useSelector(getColoring);
  const hasExistingThreads = useSelector(hasPersistedThreads);
  const {
    shouldHideQuickReplies: shouldHidePrompts,
    showConsentButton,
    consentMessage,
    consentRequired,
    spamProtectionEnabled,
    handleConsentAccept
  } = useConsentPromptDataV2();
  const {
    recommendedQuestionsForAgent,
    isAIChatBot,
    handlePromptClick,
    handlePromptTrack
  } = useAIPromptRecommendations({
    clickedFrom,
    shouldOpenWidget: true,
    shouldLoadStagedThread: true,
    errorMessage: 'Failed to publish message from pill launcher prompt'
  });
  const hasPrompts = recommendedQuestionsForAgent.length > 0;
  const shouldShowConsentPrompt = hasPrompts && consentRequired;
  const consentConfig = useMemo(() => {
    if (!shouldShowConsentPrompt) {
      return undefined;
    }
    return {
      consentMessage,
      showConsentButton,
      onConsentAccept: handleConsentAccept,
      accentColor: coloring === null || coloring === void 0 ? void 0 : coloring.accentColor,
      isAIChatBot
    };
  }, [consentMessage, shouldShowConsentPrompt, showConsentButton, handleConsentAccept, coloring === null || coloring === void 0 ? void 0 : coloring.accentColor, isAIChatBot]);
  const handlePromptBubbleClick = prompt => {
    handlePromptClick(prompt);
    handlePromptTrack();
  };
  const handleOpenWidget = () => {
    dispatch(toggleOpen({
      isOpened: true,
      isUser: true,
      openedFrom: 'pill launcher'
    }));
  };
  if (!isAIChatBot || hasExistingThreads || !hasPrompts) {
    return null;
  }
  return /*#__PURE__*/_jsx(PillLauncherExpandedView, {
    isVisible: isHoverActive,
    onOpen: handleOpenWidget,
    recommendedQuestionsForAgent: shouldHidePrompts ? [] : recommendedQuestionsForAgent,
    onPromptClick: handlePromptBubbleClick,
    coloring: coloring,
    consentConfig: consentConfig,
    spamProtectionEnabled: spamProtectionEnabled
  });
};
PillLauncherExpandedViewContainer.displayName = 'PillLauncherExpandedViewContainer';
export default PillLauncherExpandedViewContainer;